// extracted by mini-css-extract-plugin
export default {"container":"closeMenu_container__ua5c7","img":"closeMenu_img__xarnK"};